// // // // import React, { useState } from 'react';
// // // // import {
// // // //     Dialog,
// // // //     DialogTitle,
// // // //     DialogContent,
// // // //     DialogActions,
// // // //     IconButton,
// // // //     Button,
// // // //     Box,
// // // //     Typography,
// // // //     Grid,
// // // //     Table,
// // // //     TableBody,
// // // //     TableCell,
// // // //     TableContainer,
// // // //     TableHead,
// // // //     TableRow,
// // // //     Paper,

// // // // } from '@mui/material';
// // // // import { Close as CloseIcon } from '@mui/icons-material';
// // // // import { Formik, Form } from 'formik';

// // // // import { FaPlus } from "react-icons/fa6";
// // // // import { MdPayment } from 'react-icons/md';

// // // // import CustomInputLogin from '../../../Components/CustomInputLogin/CustomInputLogin';
// // // // import '../../ContentManagement/Home/Modal/BannerinputGetModal.css'// Import external CSS
// // // // import { MdCancel } from "react-icons/md";

// // // // const TableDataViewModal = ({ open, onClose, setSubmittedValues, submittedValues, modalHeadingName }) => {
// // // //     // const [uploadedFile, setUploadedFile] = useState(null);
// // // //     const [uploadedFiles, setUploadedFiles] = useState([])
// // // //     const [selectedDocumentType, setSelectedDocumentType] = React.useState('');

// // // //     const purchaser = {
// // // //         firstName: 'Mani',
// // // //         lastName: 'Krish',
// // // //         email: 'manikrish@gmail.com',
// // // //         mobileNumber: '9823281781',
// // // //         userType: 'Individual',
// // // //         documentType: 'Emirates ID',
// // // //         addressLine1: 'CL-720',
// // // //         addressLine2: 'Afza, Ajman',
// // // //         city: 'Al Ain',
// // // //         state: 'Abu Dhabi',
// // // //         country: 'United Arab Emirates',
// // // //         zipcode: '20000',
// // // //         schemes: [
// // // //             {
// // // //                 name: 'Scheme 1',
// // // //                 purchaseValue: '$1000',
// // // //                 goldValue: '13.8 g',
// // // //                 purchaseDate: '15 Jan 2025',
// // // //                 maturityDate: '15 Jan 2027',
// // // //             },
// // // //         ],
// // // //     };
// // // //     return (
// // // //         <Dialog
// // // //             open={open}
// // // //             onClose={onClose}
// // // //             fullWidth
// // // //             maxWidth="md"
// // // //             className="custom-dialog"
// // // //             sx={{
// // // //                 // maxWidth: "700px",
// // // //                 // margin: "auto",
// // // //                 "& .MuiPaper-root": {
// // // //                     borderRadius: "14px", // Target the Paper component
// // // //                 },
// // // //             }}
// // // //         >
// // // //             <Box sx={{ position: 'relative' }}>
// // // //                 <Box className="dialog-heading">
// // // //                     <IconButton
// // // //                         aria-label="Close"
// // // //                         onClick={onClose}
// // // //                         sx={{ position: 'absolute', top: 8, right: 8, color: 'text.secondary' }}
// // // //                     >
// // // //                         <MdCancel />
// // // //                     </IconButton>
// // // //                     <DialogTitle className="custom-dialog-title">

// // // //                         <Box>
// // // //                             <Typography className="custom-title-text" color='white'>
// // // //                                 {modalHeadingName}
// // // //                             </Typography>
// // // //                         </Box>
// // // //                     </DialogTitle>
// // // //                 </Box>
// // // //                 <Box p={2}>
// // // //                     <Grid container spacing={2}>
// // // //                         <Grid item xs={12}>
// // // //                             <Grid sx={{display:"flex",justifyContent:"space-between"}} spacing={2}>
// // // //                                 <Grid item md={4}>
// // // //                                     <Typography variant="body2" color="textSecondary"><strong>First Name:</strong></Typography>
// // // //                                     <Typography variant="body1">{purchaser.firstName}</Typography>
// // // //                                 </Grid>
// // // //                                 <Grid item md={4}>
// // // //                                     <Typography variant="body2" color="textSecondary"><strong>Email:</strong></Typography>
// // // //                                     <Typography variant="body1">{purchaser.email}</Typography>
// // // //                                 </Grid>
// // // //                                 <Grid item md={4}>
// // // //                                     <Typography variant="body2" color="textSecondary"><strong>Address Line 1:</strong></Typography>
// // // //                                     <Typography variant="body1">{purchaser.addressLine1}</Typography>
// // // //                                 </Grid>
// // // //                                 <Grid item md={4}>
// // // //                                     <Typography variant="body2" color="textSecondary"><strong>State:</strong></Typography>
// // // //                                     <Typography variant="body1">{purchaser.state}</Typography>
// // // //                                 </Grid>

// // // //                                 <Grid item md={4}>
// // // //                                     <Typography variant="body2" color="textSecondary"><strong>Last Name:</strong></Typography>
// // // //                                     <Typography variant="body1">{purchaser.lastName}</Typography>
// // // //                                 </Grid>
// // // //                                 <Grid item md={4}>
// // // //                                     <Typography variant="body2" color="textSecondary"><strong>Mobile Number:</strong></Typography>
// // // //                                     <Typography variant="body1">{purchaser.mobileNumber}</Typography>
// // // //                                 </Grid>
// // // //                                 <Grid item md={4}>
// // // //                                     <Typography variant="body2" color="textSecondary"><strong>Address Line 2:</strong></Typography>
// // // //                                     <Typography variant="body1">{purchaser.addressLine2}</Typography>
// // // //                                 </Grid>
// // // //                                 <Grid item md={4}>
// // // //                                     <Typography variant="body2" color="textSecondary"><strong>City:</strong></Typography>
// // // //                                     <Typography variant="body1">{purchaser.city}</Typography>
// // // //                                 </Grid>
// // // //                             </Grid>
// // // //                         </Grid>
// // // //                     </Grid>

// // // //                     <Box mt={4}>
// // // //                         <Typography variant="h6" gutterBottom>Schemes Purchased</Typography>
// // // //                         <TableContainer component={Paper}>
// // // //                             <Table>
// // // //                                 <TableHead>
// // // //                                     <TableRow>
// // // //                                         <TableCell>Scheme Name</TableCell>
// // // //                                         <TableCell>Purchase Value</TableCell>
// // // //                                         <TableCell>Gold Value</TableCell>
// // // //                                         <TableCell>Purchase Date</TableCell>
// // // //                                         <TableCell>Maturity Date</TableCell>
// // // //                                     </TableRow>
// // // //                                 </TableHead>
// // // //                                 <TableBody>
// // // //                                     {purchaser.schemes.map((scheme, index) => (
// // // //                                         <TableRow key={index}>
// // // //                                             <TableCell>{scheme.name}</TableCell>
// // // //                                             <TableCell>{scheme.purchaseValue}</TableCell>
// // // //                                             <TableCell>{scheme.goldValue}</TableCell>
// // // //                                             <TableCell>{scheme.purchaseDate}</TableCell>
// // // //                                             <TableCell>{scheme.maturityDate}</TableCell>
// // // //                                         </TableRow>
// // // //                                     ))}
// // // //                                 </TableBody>
// // // //                             </Table>
// // // //                         </TableContainer>
// // // //                     </Box>

// // // //                 </Box>
// // // //             </Box >
// // // //         </Dialog >
// // // //     );
// // // // };

// // // // export default TableDataViewModal;

// // // import React, { useState } from 'react';
// // // import {
// // //     Dialog,
// // //     DialogTitle,
// // //     DialogContent,
// // //     IconButton,
// // //     Typography,
// // //     Grid,
// // //     Table,
// // //     TableBody,
// // //     TableCell,
// // //     TableContainer,
// // //     TableHead,
// // //     TableRow,
// // //     Paper,
// // //     Box,
// // // } from '@mui/material';
// // // import { MdCancel } from "react-icons/md";
// // // import "./TableDataViewModal.css"

// // // const TableDataViewModal = ({ open, onClose, modalHeadingName }) => {
// // //     const [uploadedFiles, setUploadedFiles] = useState([]);

// // //     const purchaser = {
// // //         firstName: 'Mani',
// // //         lastName: 'Krish',
// // //         email: 'manikrish@gmail.com',
// // //         mobileNumber: '9823281781',
// // //         userType: 'Individual',
// // //         documentType: 'Emirates ID',
// // //         addressLine1: 'CL-720',
// // //         addressLine2: 'Afza, Ajman',
// // //         city: 'Al Ain',
// // //         state: 'Abu Dhabi',
// // //         country: 'United Arab Emirates',
// // //         zipcode: '20000',
// // //         schemes: [
// // //             {
// // //                 name: 'Scheme 1',
// // //                 purchaseValue: '$1000',
// // //                 goldValue: '13.8 g',
// // //                 purchaseDate: '15 Jan 2025',
// // //                 maturityDate: '15 Jan 2027',
// // //             },
// // //         ],
// // //     };

// // //     return (
// // //         <Dialog
// // //             open={open}
// // //             onClose={onClose}
// // //             fullWidth
// // //             maxWidth="md"
// // //             className="custom-dialog"
// // //             sx={{
// // //                 "& .MuiPaper-root": {
// // //                     borderRadius: "14px",
// // //                 },
// // //             }}
// // //         >
// // //             <Box sx={{ position: 'relative' }}>
// // //                 {/* Dialog Header */}
// // //                 <Box className="dialog-heading">
// // //                     <IconButton
// // //                         aria-label="Close"
// // //                         onClick={onClose}
// // //                         sx={{
// // //                             position: 'absolute',
// // //                             top: 8,
// // //                             right: 8,
// // //                             color: 'text.secondary',
// // //                         }}
// // //                     >
// // //                         <MdCancel />
// // //                     </IconButton>
// // //                     <DialogTitle className="custom-dialog-title">
// // //                         <Typography className="custom-title-text" color="white">
// // //                             {modalHeadingName}
// // //                         </Typography>
// // //                     </DialogTitle>
// // //                 </Box>

// // //                 {/* Dialog Content */}
// // //                 <Box p={4}>
// // //                     {/* Personal Details */}
// // //                     <Grid container spacing={2}>
// // //                         <Grid item xs={12}>
// // //                             <Grid sx={{ display: "flex", justifyContent: "space-between" }}>

// // //                                 <Grid item>
// // //                                     <Typography variant="body1" className='tabledataview-content-textheading'>
// // //                                         First Name
// // //                                     </Typography>
// // //                                     <Typography variant="subtitle2">{purchaser.firstName}</Typography>
// // //                                 </Grid>
// // //                                 <Grid item>

// // //                                     <Typography variant="body1" className='tabledataview-content-textheading'>
// // //                                         Last Name
// // //                                     </Typography>
// // //                                     <Typography variant="subtitle2">{purchaser.lastName}</Typography>
// // //                                 </Grid>
// // //                                 <Grid item>
// // //                                     <Typography variant="body1" className='tabledataview-content-textheading'>
// // //                                         User Type
// // //                                     </Typography>
// // //                                     <Typography variant="subtitle2">{purchaser.userType}</Typography>
// // //                                 </Grid>

// // //                             </Grid>
// // //                         </Grid>
// // //                         <Grid xs={12}
// // //                             <Grid sx={{ display: "flex", justifyContent: "space-between" }}>

// // //                             <Grid item>
// // //                                 <Typography variant="body1" className='tabledataview-content-textheading'>
// // //                                     Email
// // //                                 </Typography>
// // //                                 <Typography variant="subtitle2">{purchaser.email}</Typography>
// // //                             </Grid>
// // //                             <Grid item>

// // //                                 <Typography variant="body1" className='tabledataview-content-textheading'>
// // //                                    Mobile Number
// // //                                 </Typography>
// // //                                 <Typography variant="subtitle2">{purchaser.mobileNumber}</Typography>
// // //                             </Grid>
// // //                             <Grid item>
// // //                                 <Typography variant="body1" className='tabledataview-content-textheading'>
// // //                                     Document Type
// // //                                 </Typography>
// // //                                 <Typography variant="subtitle2">{purchaser.documentType}</Typography>
// // //                             </Grid>
// // //                         </Grid>
// // //                     </Grid>

// // //             </Box>

// // //             {/* Schemes Table */}
// // //             <Box mt={4}>
// // //                 <Typography variant="h6" gutterBottom>
// // //                     Schemes Purchased
// // //                 </Typography>
// // //                 <TableContainer component={Paper}>
// // //                     <Table>
// // //                         <TableHead>
// // //                             <TableRow>
// // //                                 <TableCell>Scheme Name</TableCell>
// // //                                 <TableCell>Purchase Value</TableCell>
// // //                                 <TableCell>Gold Value</TableCell>
// // //                                 <TableCell>Purchase Date</TableCell>
// // //                                 <TableCell>Maturity Date</TableCell>
// // //                             </TableRow>
// // //                         </TableHead>
// // //                         <TableBody>
// // //                             {purchaser.schemes.map((scheme, index) => (
// // //                                 <TableRow key={index}>
// // //                                     <TableCell>{scheme.name}</TableCell>
// // //                                     <TableCell>{scheme.purchaseValue}</TableCell>
// // //                                     <TableCell>{scheme.goldValue}</TableCell>
// // //                                     <TableCell>{scheme.purchaseDate}</TableCell>
// // //                                     <TableCell>{scheme.maturityDate}</TableCell>
// // //                                 </TableRow>
// // //                             ))}
// // //                         </TableBody>
// // //                     </Table>
// // //                 </TableContainer>
// // //             </Box>

// // //         </Dialog >
// // //     );
// // // };

// // // export default TableDataViewModal;

// // import React from 'react';
// // import {
// //     Dialog,
// //     DialogTitle,
// //     DialogContent,
// //     IconButton,
// //     Typography,
// //     Grid,
// //     Table,
// //     TableBody,
// //     TableCell,
// //     TableContainer,
// //     TableHead,
// //     TableRow,
// //     Paper,
// //     Box,
// // } from '@mui/material';
// // import { MdCancel } from "react-icons/md";
// // import "./TableDataViewModal.css";

// // const TableDataViewModal = ({ open, onClose, modalHeadingName }) => {
// //     const purchaser = {
// //         firstName: 'Mani',
// //         lastName: 'Krish',
// //         email: 'manikrish@gmail.com',
// //         mobileNumber: '9823281781',
// //         userType: 'Individual',
// //         documentType: 'Emirates ID',
// //         addressLine1: 'CL-720',
// //         addressLine2: 'Afza, Ajman',
// //         city: 'Al Ain',
// //         state: 'Abu Dhabi',
// //         country: 'United Arab Emirates',
// //         zipcode: '20000',
// //         schemes: [
// //             {
// //                 name: 'Scheme 1',
// //                 purchaseValue: '$1000',
// //                 goldValue: '13.8 g',
// //                 purchaseDate: '15 Jan 2025',
// //                 maturityDate: '15 Jan 2027',
// //             },
// //         ],
// //     };

// //     return (
// //         <Dialog
// //             open={open}
// //             onClose={onClose}
// //             fullWidth
// //             maxWidth="md"
// //             className="custom-dialog"
// //             sx={{
// //                 "& .MuiPaper-root": {
// //                     borderRadius: "14px",
// //                 },
// //             }}
// //         >
// //             <Box sx={{ position: 'relative' }}>
// //                 {/* Dialog Header */}
// //                 <Box className="dialog-heading">
// //                     <IconButton
// //                         aria-label="Close"
// //                         onClick={onClose}
// //                         sx={{
// //                             position: 'absolute',
// //                             top: 8,
// //                             right: 8,
// //                             color: 'text.secondary',
// //                         }}
// //                     >
// //                         <MdCancel />
// //                     </IconButton>
// //                     <DialogTitle className="custom-dialog-title">
// //                         <Typography className="custom-title-text" color="white">
// //                             {modalHeadingName}
// //                         </Typography>
// //                     </DialogTitle>
// //                 </Box>
// //             </Box>

// //             <DialogContent>
// //                 <Box p={{xs:0,md:2}}>
// //                     <Grid container spacing={4}>
// //                         <Grid item xs={6} md={4}>
// //                             <Typography variant="body1" className="tabledataview-content-textheading">
// //                                 First Name
// //                             </Typography>
// //                             <Typography variant="subtitle2">{purchaser.firstName}</Typography>
// //                         </Grid>
// //                         <Grid item xs={6} md={4}>
// //                             <Typography variant="body1" className="tabledataview-content-textheading">
// //                                 Last Name
// //                             </Typography>
// //                             <Typography variant="subtitle2">{purchaser.lastName}</Typography>
// //                         </Grid>
// //                         <Grid item xs={6} md={4}>
// //                             <Typography variant="body1" className="tabledataview-content-textheading">
// //                                 User Type
// //                             </Typography>
// //                             <Typography variant="subtitle2">{purchaser.userType}</Typography>
// //                         </Grid>
// //                         <Grid item xs={4}>
// //                             <Typography variant="body1" className="tabledataview-content-textheading">
// //                                 Email
// //                             </Typography>
// //                             <Typography variant="subtitle2">{purchaser.email}</Typography>
// //                         </Grid>
// //                         <Grid item xs={4}>
// //                             <Typography variant="body1" className="tabledataview-content-textheading">
// //                                 Mobile Number
// //                             </Typography>
// //                             <Typography variant="subtitle2">{purchaser.mobileNumber}</Typography>
// //                         </Grid>
// //                         <Grid item xs={4}>
// //                             <Typography variant="body1" className="tabledataview-content-textheading">
// //                                 Document Type
// //                             </Typography>
// //                             <Typography variant="subtitle2">{purchaser.documentType}</Typography>
// //                         </Grid>
// //                     </Grid>

// //                     <Box mt={4}>
// //                         <Typography variant="h6" gutterBottom>
// //                             Schemes Purchased
// //                         </Typography>
// //                         <TableContainer component={Paper}>
// //                             <Table>
// //                                 <TableHead>
// //                                     <TableRow>
// //                                         <TableCell>Scheme Name</TableCell>
// //                                         <TableCell>Purchase Value</TableCell>
// //                                         <TableCell>Gold Value</TableCell>
// //                                         <TableCell>Purchase Date</TableCell>
// //                                         <TableCell>Maturity Date</TableCell>
// //                                     </TableRow>
// //                                 </TableHead>
// //                                 <TableBody>
// //                                     {purchaser.schemes.map((scheme, index) => (
// //                                         <TableRow key={index}>
// //                                             <TableCell>{scheme.name}</TableCell>
// //                                             <TableCell>{scheme.purchaseValue}</TableCell>
// //                                             <TableCell>{scheme.goldValue}</TableCell>
// //                                             <TableCell>{scheme.purchaseDate}</TableCell>
// //                                             <TableCell>{scheme.maturityDate}</TableCell>
// //                                         </TableRow>
// //                                     ))}
// //                                 </TableBody>
// //                             </Table>
// //                         </TableContainer>
// //                     </Box>
// //                 </Box>
// //             </DialogContent>
// //         </Dialog>
// //     );
// // };

// // export default TableDataViewModal;

// import React from 'react';
// import {
//     Dialog,
//     DialogTitle,
//     DialogContent,
//     IconButton,
//     Typography,
//     Grid,
//     Table,
//     TableBody,
//     TableCell,
//     TableContainer,
//     TableHead,
//     TableRow,
//     Paper,
//     Box,
// } from '@mui/material';
// import { MdCancel } from "react-icons/md";
// import "./TableDataViewModal.css";

// const TableDataViewModal = ({ open, onClose, modalHeadingName }) => {
//     const purchaser = {
//         firstName: 'Mani',
//         lastName: 'Krish',
//         email: 'manikrish@gmail.com',
//         mobileNumber: '9823281781',
//         userType: 'Individual',
//         documentType: 'Emirates ID',
//         addressLine1: 'CL-720',
//         addressLine2: 'Afza, Ajman',
//         city: 'Al Ain',
//         state: 'Abu Dhabi',
//         country: 'United Arab Emirates',
//         zipcode: '20000',
//         schemes: [
//             {
//                 name: 'Scheme 1',
//                 purchaseValue: '$1000',
//                 goldValue: '13.8 g',
//                 purchaseDate: '15 Jan 2025',
//                 maturityDate: '15 Jan 2027',
//             },
//         ],
//     };

//     return (
//         <Dialog
//             open={open}
//             onClose={onClose}
//             fullWidth
//             maxWidth="md"
//             className="custom-dialog"
//             sx={{
//                 "& .MuiPaper-root": {
//                     borderRadius: "14px",
//                 },
//             }}
//         >
//             <Box sx={{ position: 'relative' }}>
//                 {/* Dialog Header */}
//                 <Box className="dialog-heading">
//                     <IconButton
//                         aria-label="Close"
//                         onClick={onClose}
//                         sx={{
//                             position: 'absolute',
//                             top: 8,
//                             right: 8,
//                             color: 'text.secondary',
//                         }}
//                     >
//                         <MdCancel />
//                     </IconButton>
//                     <DialogTitle className="custom-dialog-title">
//                         <Typography className="custom-title-text" color="white">
//                             {modalHeadingName}
//                         </Typography>
//                     </DialogTitle>
//                 </Box>
//             </Box>

//             <DialogContent>
//                 <Box p={{ xs: 2, md: 3 }}>
//                     {/* <Grid container spacing={3}> */}
//                     <Grid container spacing={2} alignItems="center" justifyContent="space-between" >

//                         <Grid item xs={12} md={4} justifyContent="start">
//                             <Typography variant="body1" className="tabledataview-content-textheading">
//                                 First Name
//                             </Typography>
//                             <Typography variant="subtitle2">{purchaser.firstName}</Typography>
//                         </Grid>
//                         <Grid item xs={12} md={4} justifyContent="center">
//                             <Typography variant="body1" className="tabledataview-content-textheading">
//                                 Last Name
//                             </Typography>
//                             <Typography variant="subtitle2">{purchaser.lastName}</Typography>
//                         </Grid>
//                         <Grid item xs={12} md={4} justifyContent="end">
//                             <Typography variant="body1" className="tabledataview-content-textheading">
//                                 User Type
//                             </Typography>
//                             <Typography variant="subtitle2">{purchaser.userType}</Typography>
//                         </Grid>
//                         <Grid item xs={12} md={4}>
//                             <Typography variant="body1" className="tabledataview-content-textheading">
//                                 Email
//                             </Typography>
//                             <Typography variant="subtitle2">{purchaser.email}</Typography>
//                         </Grid>
//                         <Grid item xs={12} md={4}>
//                             <Typography variant="body1" className="tabledataview-content-textheading">
//                                 Mobile Number
//                             </Typography>
//                             <Typography variant="subtitle2">{purchaser.mobileNumber}</Typography>
//                         </Grid>
//                         <Grid item xs={12} md={4}>
//                             <Typography variant="body1" className="tabledataview-content-textheading">
//                                 Document Type
//                             </Typography>
//                             <Typography variant="subtitle2">{purchaser.documentType}</Typography>
//                         </Grid>
//                     </Grid>

//                     <Box mt={4}>
//                         <Typography variant="h6" gutterBottom>
//                             Schemes Purchased
//                         </Typography>
//                         <TableContainer component={Paper}>
//                             <Table>
//                                 <TableHead>
//                                     <TableRow>
//                                         <TableCell>Scheme Name</TableCell>
//                                         <TableCell>Purchase Value</TableCell>
//                                         <TableCell>Gold Value</TableCell>
//                                         <TableCell>Purchase Date</TableCell>
//                                         <TableCell>Maturity Date</TableCell>
//                                     </TableRow>
//                                 </TableHead>
//                                 <TableBody>
//                                     {purchaser.schemes.map((scheme, index) => (
//                                         <TableRow key={index}>
//                                             <TableCell>{scheme.name}</TableCell>
//                                             <TableCell>{scheme.purchaseValue}</TableCell>
//                                             <TableCell>{scheme.goldValue}</TableCell>
//                                             <TableCell>{scheme.purchaseDate}</TableCell>
//                                             <TableCell>{scheme.maturityDate}</TableCell>
//                                         </TableRow>
//                                     ))}
//                                 </TableBody>
//                             </Table>
//                         </TableContainer>
//                     </Box>
//                 </Box>
//             </DialogContent>
//         </Dialog>
//     );
// };

// export default TableDataViewModal;

import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Divider,
} from "@mui/material";
import { MdCancel } from "react-icons/md";
import "./TableDataViewModal.css";
import documentImage from "../../../Assets/Emirates_ID_Card_For_UAE_Citizens_(New).png";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../../ReduxStore/actions/index";
import { adminUrl } from "../../../constants/url";
import { toast, ToastContainer } from "react-toastify";
import { format } from "date-fns";

const TableDataViewModal = ({ open, onClose, modalViewHeadingName }) => {
  const purchaser = {
    firstName: "Mani",
    lastName: "Krish",
    email: "manikrish@gmail.com",
    mobileNumber: "9823281781",
    userType: "Individual",
    documentType: "Emirates ID",
    addressLine1: "CL-720",
    addressLine2: "Afza, Ajman",
    city: "Al Ain",
    state: "Abu Dhabi",
    country: "United Arab Emirates",
    zipcode: "20000",
    schemes: [
      {
        name: "Scheme 1",
        purchaseValue: "$1000",
        goldValue: "13.8 g",
        purchaseDate: "15 Jan 2025",
        maturityDate: "15 Jan 2027",
      },
    ],
  };
  const TableHeadModalData = [
    "Scheme Name",
    "Purchase Value",
    "Gold Value",
    "Purchase Date",
    "Maturity Date",
  ];

  const Documents = [documentImage, documentImage, documentImage];

  // ------------------------------------------

  const handleDownload = (fileUrl, fileName) => {
    fetch(fileUrl)
      .then((response) => response.blob()) // Convert response to blob
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName; // Set filename
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url); // Clean up memory
      })
      .catch((error) => console.error("Download error:", error));
  };

  console.log(adminUrl, "adminUrladminUrladminUrl");

  const dispatch = useDispatch();
  // const purchaser = {
  //     firstName: 'Mani',
  //     lastName: 'Krish',
  //     email: 'manikrish@gmail.com',
  //     mobileNumber: '9823281781',
  //     userType: 'Individual',
  //     documentType: 'Emirates ID',
  //     addressLine1: 'CL-720',
  //     addressLine2: 'Afza, Ajman',
  //     city: 'Al Ain',
  //     state: 'Abu Dhabi',
  //     country: 'United Arab Emirates',
  //     zipcode: '20000',
  //     schemes: [
  //         {
  //             name: 'Mani Krish',
  //             email: 'manikrish@gmail.com',
  //             useType: 'Financial Consultant',
  //             JoindOnDate: '15 Jan 2025',

  //         },
  //     ],
  // };
  // const TableHeadModalData = ["Referrer Name", "Email", "User Type", 'Joined on']

  // const Documents = [documentImage, documentImage, documentImage]

  const { getPurchaseById } = useSelector((state) => state?.getPurchaseById);
  const customerId = useSelector((state) => state.customer.customerId);
  console.log(customerId, "customerId");

  console.log(getPurchaseById?.data, "getPurchaseByIdgetPurchaseById");

  // useEffect(() => {
  //   const fetchData = async () => {
  //     if (customerId) {
  //       const data1 = {
  //         data: {},
  //         method: "get",
  //         apiName: `getPurchaseById/${customerId}`,
  //       };
  //       await dispatch(actions.GETPURCHASEBYID(data1));
  //     }
  //   };
  //   fetchData();
  // }, [dispatch, customerId]);

  const [rowTableData, setRowTableData] = useState([]);
  console.log(rowTableData,"modalTablepurchase")

  const [purchaserDetails, setPurchaserDetails] = useState([])
  
  useEffect(() => {
  if(!open) return;
    const fetchData = async () => {
      if (customerId) {
        const data1 = {
          data: {},
          method: "get",
          apiName: `getPurchaseById/${customerId}`,
        };
  
        try {
          const responseData = await dispatch(actions.GETPURCHASEBYID(data1));
  
          setRowTableData([{
            title: responseData?.payload?.data?.title,
            value_of_purchase: responseData?.payload?.data?.value_of_purchase,
            purchase_stake: responseData?.payload?.data?.purchase_stake,
            purchase_date: format(new Date(responseData?.payload?.data?.purchase_date), 'MMMM d, yyyy'),
            stake_maturity: format(new Date(responseData?.payload?.data?.stake_maturity), 'MMMM d, yyyy'),
          }]);
  
          const purchaseValues = [
            { label: "First Name", value: responseData?.payload?.data?.customer?.first_name },
            { label: "Last Name", value: responseData?.payload?.data?.customer?.last_name },
            { label: "Email", value: responseData?.payload?.data?.customer?.email },
            { label: "Customer Id", value: responseData?.payload?.data?.customer?.customer_id },
            { label: "Purchase Id", value: responseData?.payload?.data?.purchase_id },
            { label: "Purchase Date", value: format(new Date(responseData?.payload?.data?.purchase_date), 'MMMM d, yyyy') },
            { label: "Stake Starting", value: format(new Date(responseData?.payload?.data?.stake_starting), 'MMMM d, yyyy') },
            { label: "Stake Maturity", value: format(new Date(responseData?.payload?.data?.stake_maturity), 'MMMM d, yyyy') },
            { label: "Payment Type", value: responseData?.payload?.data?.payment_type },
            { label: "Reap Percentage", value: `${responseData?.payload?.data?.reap_percentage} %` },
            { label: "Reap Months", value: `${responseData?.payload?.data?.reap_months} months` },
            { label: "Payment Type", value: responseData?.payload?.data?.payment_type },
          ];
  
          setPurchaserDetails(purchaseValues);
        } catch (error) {
          console.error("Error fetching purchase details:", error);
        }
      }
    };
  
    fetchData();
  }, [dispatch, customerId]);
  


const { approveCustomer } = useSelector((state) => state?.approveCustomer);

const customerRegisterApprove = async (id) => {
  console.log(id, "customerRegisterApprovecustomerRegisterApprove");

  const data1 = {
    data: {},
    method: "patch",
    apiName: `approveCustomer/${id}`,
  };
  const approveCustomerResponse = await dispatch(
    actions.APPROVECUSTOMER(data1)
  );

  console.log(
    approveCustomerResponse.payload.message,
    "approveCustomerResponse"
  );

  if (
    approveCustomerResponse.payload.message ===
    "Customer status changed to approved successfully."
  ) {
    toast.success("Approved Successfully.");
    setTimeout(() => onClose(), 1500);
  }

  if (
    approveCustomerResponse.payload.message ===
    "Customer is already approved."
  ) {
    toast.error("Customer is already approved.");
    setTimeout(() => onClose(), 1500);
  }
};

return (
  <Dialog
    open={open}
    // onClose={onClose}
    fullWidth
    maxWidth="md"
    className="custom-dialog"
    sx={{
      "& .MuiPaper-root": {
        borderRadius: "14px",
      },
    }}
  >
    <Box sx={{ position: "relative" }}>
      {/* Dialog Header */}
      <Box className="dialog-heading">
        <IconButton
          aria-label="Close"
          onClick={onClose}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            color: "text.secondary",
          }}
        >
          <MdCancel />
        </IconButton>
        <DialogTitle className="custom-dialog-title">
          <Typography className="custom-title-text" color="white">
            {modalViewHeadingName}
          </Typography>
        </DialogTitle>
      </Box>
    </Box>

    <DialogContent>
      <Box p={{ xs: 2, md: 1 }}>
        {/* <Grid sx={{ display: "flex", justifyContent: "space-between", flexDirection: { xs: "column", md: "row" } }}>
                       


                        <Grid item >
                            <Box className="content-layout">
                                <Typography variant="body1" className="tabledataview-content-textheading">
                                    First Name
                                </Typography>
                                <Typography variant="subtitle2">{purchaser.firstName}</Typography>
                            </Box>
                        </Grid>
                        <Grid item >
                            <Box className="content-layout">
                                <Typography variant="body1" className="tabledataview-content-textheading">
                                    Last Name
                                </Typography>
                                <Typography variant="subtitle2">{purchaser.lastName}</Typography>
                            </Box>
                        </Grid>
                        <Grid item  >
                            <Box className="content-layout">
                                <Typography variant="body1" className="tabledataview-content-textheading">
                                    User Type
                                </Typography>
                                <Typography variant="subtitle2">{purchaser.userType}</Typography>
                            </Box>
                        </Grid>
                    </Grid>
                    <Grid sx={{ display: "flex", justifyContent: "space-between", flexDirection: { xs: "column", md: "row" } }}>

                        <Grid item >
                            <Box className="content-layout">
                                <Typography variant="body1" className="tabledataview-content-textheading">
                                    Email
                                </Typography>
                                <Typography variant="subtitle2">{purchaser.email}</Typography>
                            </Box>
                        </Grid>
                        <Grid item  >
                            <Box className="content-layout">
                                <Typography variant="body1" className="tabledataview-content-textheading">
                                    Mobile Number
                                </Typography>
                                <Typography variant="subtitle2">{purchaser.mobileNumber}</Typography>
                            </Box>
                        </Grid>
                        <Grid item  >
                            <Box className="content-layout">
                                <Typography variant="body1" className="tabledataview-content-textheading">
                                    Document Type
                                </Typography>
                                <Typography variant="subtitle2">{purchaser.documentType}</Typography>
                            </Box>
                        </Grid>
                    </Grid>
                    <Grid sx={{ display: "flex", justifyContent: "space-between", flexDirection: { xs: "column", md: "row" } }}>

                        <Grid item >
                            <Box className="content-layout">
                                <Typography variant="body1" className="tabledataview-content-textheading">
                                    Address Line 1
                                </Typography>
                                <Typography variant="subtitle2">{purchaser.addressLine1}</Typography>
                            </Box>
                        </Grid>
                        <Grid item >
                            <Box className="content-layout">
                                <Typography variant="body1" className="tabledataview-content-textheading">
                                    Address Line 2
                                </Typography>
                                <Typography variant="subtitle2">{purchaser.addressLine2}</Typography>
                            </Box>
                        </Grid>
                        <Grid item  >
                            <Box className="content-layout">
                                <Typography variant="body1" className="tabledataview-content-textheading">
                                    City
                                </Typography>
                                <Typography variant="subtitle2">{purchaser.city}</Typography>
                            </Box>
                        </Grid>
                    </Grid>
                    <Grid sx={{ display: "flex", justifyContent: "space-between", flexDirection: { xs: "column", md: "row" } }}>

                        <Grid item  >
                            <Box className="content-layout">
                                <Typography variant="body1" className="tabledataview-content-textheading">
                                    State
                                </Typography>
                                <Typography variant="subtitle2">{purchaser.state}</Typography>
                            </Box>
                        </Grid>
                        <Grid item >
                            <Box className="content-layout">
                                <Typography variant="body1" className="tabledataview-content-textheading">
                                    country
                                </Typography>
                                <Typography variant="subtitle2">{purchaser.country}</Typography>
                            </Box>
                        </Grid>
                        <Grid item  >
                            <Box className="content-layout">
                                <Typography variant="body1" className="tabledataview-content-textheading">
                                    Zipcode
                                </Typography>
                                <Typography variant="subtitle2">{purchaser.zipcode}</Typography>
                            </Box>
                        </Grid>
                    </Grid> */}

        <Grid container spacing={2}>
          {purchaserDetails.map((item, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Box className="content-layout">
                <Typography
                  variant="body1"
                  className="tabledataview-content-textheading"
                >
                  {item.label}
                </Typography>
                <Typography variant="subtitle2">{item.value}</Typography>
              </Box>
            </Grid>
          ))}
        </Grid>

        <Divider sx={{ mt: 3 }} />

        {/* Schemes Table */}
        <Box mt={4}>
          <Typography variant="body2" gutterBottom>
            Schemes Purchased
          </Typography>
          <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
            <Table sx={{ borderCollapse: "collapse" }}>
              <TableHead>
                <TableRow sx={{ p: "16px 0" }}>
                  {TableHeadModalData.map((data, index) => (
                    <TableCell
                      sx={{
                        color: "#7A7A7A",
                        border: "none",
                        p: "10px 10px 0 0px",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                      }}
                    >
                      <Typography variant="body1"> {data}</Typography>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {rowTableData.map((scheme, index) => (
                  <TableRow key={index}>
                    {Object.keys(scheme).map((key) => (
                      <TableCell
                        key={key}
                        sx={{
                          border: "none",
                          p: "10px 10px 0 0px",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                        }}
                      >
                        <Typography variant="subtitle2">
                          {scheme[key]}
                        </Typography>
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        {/* <Divider sx={{ mt: 3 }} /> */}

        {/* <Grid xs={12} mt={1}>
          <Typography variant="body2">Documents</Typography>
          <Grid container spacing={2} mt={1}>
            {Documents.map((data, index) => (
              <Grid item xs={12} md={4} key={index}>
                <Box
                  sx={{
                    p: 1,
                    background: "white",
                    boxShadow: 2,
                    borderRadius: "5px",
                  }}
                >
                  <Box
                    component="img"
                    src={data}
                    height="200px"
                    width="100%"
                    display="block"
                    margin="0" // Center the image within the grid cell
                  />
                </Box>
              </Grid>
            ))}
          </Grid>
        </Grid> */}
      </Box>
    </DialogContent>
  </Dialog>
);
};

export default TableDataViewModal;

// import React from 'react';
// import {
//     Dialog,
//     DialogTitle,
//     DialogContent,
//     IconButton,
//     Typography,
//     Grid,
//     Table,
//     TableBody,
//     TableCell,
//     TableContainer,
//     TableHead,
//     TableRow,
//     Paper,
//     Box,
//     Divider,
// } from '@mui/material';
// import { MdCancel } from "react-icons/md";
// import "./TableDataViewModal.css";

// const TableDataViewModal = ({ open, onClose, modalHeadingName }) => {
//     const purchaser = {
//         firstName: 'Mani',
//         lastName: 'Krish',
//         email: 'manikrish@gmail.com',
//         mobileNumber: '9823281781',
//         userType: 'Individual',
//         documentType: 'Emirates ID',
//         addressLine1: 'CL-720',
//         addressLine2: 'Afza, Ajman',
//         city: 'Al Ain',
//         state: 'Abu Dhabi',
//         country: 'United Arab Emirates',
//         zipcode: '20000',
//         schemes: [
//             {
//                 name: 'Scheme 1',
//                 purchaseValue: '$1000',
//                 goldValue: '13.8 g',
//                 purchaseDate: '15 Jan 2025',
//                 maturityDate: '15 Jan 2027',
//             },
//             {
//                 name: 'Scheme 2',
//                 purchaseValue: '$1000',
//                 goldValue: '13.8 g',
//                 purchaseDate: '15 Jan 2025',
//                 maturityDate: '15 Jan 2027',
//             },
//         ],
//     };

//     const TableHeadModalData = ["Scheme Name", "Purchase Value", "Gold Value", 'Purchase Date', "Maturity Date"]
//     return (
//         <Dialog
//             open={open}
//             onClose={onClose}
//             fullWidth
//             maxWidth="md"
//             className="custom-dialog"
//             sx={{
//                 "& .MuiPaper-root": {
//                     borderRadius: "14px",
//                 },
//             }}
//         >
//             <Box sx={{ position: 'relative' }}>
//                 {/* Dialog Header */}
//                 <Box className="dialog-heading">
//                     <IconButton
//                         aria-label="Close"
//                         onClick={onClose}
//                         sx={{
//                             position: 'absolute',
//                             top: 8,
//                             right: 8,
//                             color: 'text.secondary',
//                         }}
//                     >
//                         <MdCancel />
//                     </IconButton>
//                     <DialogTitle className="custom-dialog-title">
//                         <Typography className="custom-title-text" color="white">
//                             {modalHeadingName}
//                         </Typography>
//                     </DialogTitle>
//                 </Box>
//             </Box>

//             <DialogContent>
//                 <Box p={{ xs: 2, md: 3 }}>
//                     <Grid container spacing={2}>
//                         {/* Flex Grid for User Info */}
//                         {[
//                             { label: 'First Name', value: purchaser.firstName },
//                             { label: 'Last Name', value: purchaser.lastName },
//                             { label: 'User Type', value: purchaser.userType },
//                             { label: 'Email', value: purchaser.email },
//                             { label: 'Mobile Number', value: purchaser.mobileNumber },
//                             { label: 'Document Type', value: purchaser.documentType },
//                             { label: 'Address Line 1', value: purchaser.addressLine1 },
//                             { label: 'Address Line 2', value: purchaser.addressLine2 },
//                             { label: 'City', value: purchaser.city },
//                             { label: 'State', value: purchaser.state },
//                             { label: 'Country', value: purchaser.country },
//                             { label: 'Zipcode', value: purchaser.zipcode },
//                         ].map((field, index) => (
//                             <Grid item xs={12} sm={4} key={index} width="100%"> {/* Each item takes up 4 columns on small screens */}
//                                 <Box display="flex" flexDirection="column" justifyContent="space-between">
//                                     <Typography variant="body1" className="tabledataview-content-textheading">
//                                         {field.label}
//                                     </Typography>
//                                     <Typography variant="subtitle2">{field.value}</Typography>
//                                 </Box>
//                             </Grid>
//                         ))}
//                     </Grid>
//                     <Divider sx={{ mt: 3 }} />

//                     {/* Schemes Table */}
//                     <Box mt={4}>
//                         <Typography variant="body2" gutterBottom>
//                             Schemes Purchased
//                         </Typography>
//                         <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
//                             <Table sx={{ borderCollapse: 'collapse' }}>
//                                 <TableHead>
//                                     <TableRow sx={{ p: "16px 0" }}>
//                                         {TableHeadModalData.map((data, index) => (

//                                             <TableCell sx={{ color: "#7A7A7A", border: "none", p: "10px 0" }}>
//                                                 <Typography variant='body1'> {data}</Typography></TableCell>
//                                         ))}
//                                     </TableRow>
//                                 </TableHead>

//                                 <TableBody>
//                                     {purchaser.schemes.map((scheme, index) => (
//                                         <TableRow key={index}>
//                                             {Object.keys(scheme).map((key) => (
//                                                 <TableCell key={key} sx={{ border: "none", p: "6px 0" }} >
//                                                     <Typography variant='subtitle2'>
//                                                         {scheme[key]}
//                                                     </Typography>
//                                                 </TableCell>
//                                             ))}
//                                         </TableRow>
//                                     ))}
//                                 </TableBody>

//                             </Table>
//                         </TableContainer>
//                     </Box>
//                     <Divider sx={{ mt: 3 }} />

//                 </Box>
//             </DialogContent>
//         </Dialog >
//     );
// };

// export default TableDataViewModal;
